import React from 'react';

type Props = {
  question?: string;
  incomplete?: boolean;
  uuid: string;
  highlight?: boolean;
}

const Question: React.FC<Props> = ({
  question,
  incomplete,
  uuid,
  highlight,
}: Props) => (
  <div id={highlight ? `highlight-${uuid}` : undefined} className="pt2 pb2 pl0 mt2">
    <span className="color-quip fs-18" style={incomplete ? { color: 'red' } : undefined}>{question}</span>
  </div>
);

export default Question;
